import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductHeroContainer/index.js";
const variants = import.meta.webpackContext("/components/ProductHeroContainer", { recursive: true, regExp: /\.\/__variants__\/plp\-mweb\-image\-gallery\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });